import styled from "styled-components";

export const ContentFormCreate = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  max-width: 1060px;
`;
